import { Link } from "react-router-dom";
import { ShoppingBag } from "lucide-react";

export default function Cancel() {
  return (
    <div data-testid="cancel-page" className="pt-40 pb-24 px-6 min-h-[70vh] bg-[#F8F5F0] text-center">
      <ShoppingBag className="w-12 h-12 text-[#C6A769] mx-auto" strokeWidth={1.2} />
      <p className="mt-6 text-xs uppercase tracking-[0.3em] text-[#C6A769]" style={{ fontFamily: "'Jost', sans-serif" }}>
        Checkout Canceled
      </p>
      <h1 className="mt-4 text-4xl sm:text-5xl text-[#4A3F35]" style={{ fontFamily: "'Playfair Display', serif" }}>
        No rush, <span style={{ fontFamily: "'Great Vibes', cursive" }} className="text-[#C6A769]">beautiful.</span>
      </h1>
      <p className="mt-4 text-[#8A7D71] leading-relaxed max-w-md mx-auto" style={{ fontFamily: "'Jost', sans-serif" }}>
        Your cart is exactly as you left it. Come back whenever you're ready.
      </p>
      <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-5">
        <Link
          to="/cart"
          data-testid="cancel-return-cart"
          className="bg-[#4A3F35] text-[#FAF7F2] px-9 py-4 rounded-sm text-sm uppercase tracking-[0.15em] hover:bg-[#C6A769] transition-colors duration-500"
        >
          Return to Cart
        </Link>
        <Link
          to="/shop"
          data-testid="cancel-back-shop"
          className="border border-[#C6A769] text-[#4A3F35] px-9 py-4 rounded-sm text-sm uppercase tracking-[0.15em] hover:bg-[#C6A769] hover:text-[#FAF7F2] transition-colors duration-500"
        >
          Keep Shopping
        </Link>
      </div>
    </div>
  );
}
